import { createCategoryBodySchema } from '@klopotun/contracts';
import { z } from 'zod';
import type { CategoryFormValues } from '../model/category-form-values.js';
import { toCategoryBodyDraft } from './category-form-adapter.js';

type Complaint = {
  field: keyof CategoryFormValues;
  message: string;
};

const COMPLAINT_BY_BODY_FIELD: Record<string, Complaint> = {
  name: { field: 'name', message: 'Вкажіть назву категорії' },
  emoji: { field: 'emoji', message: 'Емодзі не підходить' },
  color: { field: 'color', message: 'Колір не підходить' },
  sortOrder: { field: 'name', message: 'Не вдалося визначити місце категорії в переліку' },
};

const FALLBACK_COMPLAINT: Complaint = {
  field: 'name',
  message: 'Дані форми не пройшли перевірку',
};

const complaintFor = (path: PropertyKey[]): Complaint => {
  const [firstSegment] = path;

  if (typeof firstSegment !== 'string') {
    return FALLBACK_COMPLAINT;
  }

  return COMPLAINT_BY_BODY_FIELD[firstSegment] ?? FALLBACK_COMPLAINT;
};

const categoryFormValuesSchema = z.object({
  name: z.string(),
  emoji: z.string(),
  color: z.string(),
  sortOrder: z.number(),
});

const checkAgainstContract = (values: CategoryFormValues, ctx: z.RefinementCtx): void => {
  const checked = createCategoryBodySchema.safeParse(toCategoryBodyDraft(values));

  if (checked.success) {
    return;
  }

  for (const issue of checked.error.issues) {
    const complaint = complaintFor(issue.path);

    ctx.addIssue({ code: 'custom', path: [complaint.field], message: complaint.message });
  }
};

export const categoryFormSchema = categoryFormValuesSchema.superRefine(checkAgainstContract);
